module.exports = __webpack_public_path__ + "img/Picture28.02c5dc10.png";